import React from 'react'

import MarkdownTypography from 'components/MarkdownTypography'

import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'

interface Props {
  imageUrl?: string | null
  title?: string | null
  message?: string | null
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: `${theme.spacing() * 2}px ${theme.spacing()}px`,
    '& p': {
      marginTop: theme.spacing(),
      marginBottom: 0,
    },
  },
  image: {
    marginRight: theme.spacing(),
    height: 96,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const QuizOutcome: React.SFC<InjectedProps> = ({ imageUrl, title, message, classes }) => (
  <Grid container wrap="nowrap" justify="center" alignItems="center" className={classes.root}>
    {imageUrl && <img alt="" src={imageUrl} className={classes.image} />}
    <Grid item>
      <MarkdownTypography lexer="inline" variant="h6" markdown={title} />
      <MarkdownTypography markdown={message} />
    </Grid>
  </Grid>
)

export default withStyles(styles)(QuizOutcome)
